import React from "react";
import { Route, Redirect } from "react-router-dom";

class PrivateRoute extends React.Component {
  render() {
    // eslint-disable-next-line
    const { component, ...rest } = this.props;

    window.scrollTo(0, 0); // Scroll to top

    return <Route {...rest} render={this.renderComponent.bind(this)} />;
  }

  renderComponent(props) {
    const { component: ComponentClass, role, location } = this.props;
    const token = localStorage.getItem("token");
    const userRole = localStorage.getItem("role");

    let component = <ComponentClass {...props} />;

    if (!token || !role.includes(userRole)) {
      component = <Redirect to="/log-in" />;
      localStorage.clear();
      localStorage.setItem("redirectUrlAfterLogin", location.pathname);
      localStorage.setItem("redirectRoleAfterLogin", role);
    } else if (this.shouldMemberBeRedirectedToConfirmationPage()) {
      component = <Redirect to="/member/confirmation" />;
    }

    return component;
  }

  shouldMemberBeRedirectedToConfirmationPage() {
    const status = localStorage.getItem("status");
    const whiteList = [
      "applied",
      "waiting-for-references",
      "pending-interview"
    ];

    const isPartOfTheList = whiteList.indexOf(status) !== -1;

    return isPartOfTheList && this.props.path !== "/member/confirmation";
  }
}

export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/routes/common/content/PrivateRoute/PrivateRoute.js